import { useEffect, useState } from "react";

let deferred = null;
const listeners = new Set();
const emit = () => listeners.forEach((fn) => fn(deferred));

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; emit(); });
  window.addEventListener("appinstalled", () => { deferred = null; emit(); });
}

export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export function useInstallPrompt() {
  const [prompt, setPrompt] = useState(deferred);
  useEffect(() => { listeners.add(setPrompt); return () => listeners.delete(setPrompt); }, []);
  const install = async () => {
    if (!deferred) return false;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    deferred = null; emit();
    return outcome === "accepted";
  };
  return { canPrompt: Boolean(prompt), install, installed: isStandalone(), ios: isIOS() };
}

export function registerServiceWorker() {
  if ("serviceWorker" in navigator) window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}
